import { ApiService } from "services/Api.service";
import { UserService } from "services/user/User.service";

import { Config, ConfigDTO } from "models/application/Config";

export class ApplicationService {
  private _apiService: ApiService;
  private _userService: UserService;

  private _config: Config;

  constructor(apiService: ApiService, userService: UserService) {
    this._apiService = apiService;
    this._userService = userService;
    this._config = new Config({ name: "admin-manage" });
  }

  public get config() {
    return this._config;
  }

  public async fetchConfig(): Promise<Config> {
    const config = Config.create({
      name: "admin-manage"
    });

    this._config = config;

    return Promise.resolve(config);
    // eslint-disable-next-line
    return await this._apiService
      .get<ConfigDTO>("/overmind/application/settings")
      .then((config: ConfigDTO) => new Config(config))
      .then((config: Config) => (this._config = config));
  }

  public async init() {
    return await Promise.all([this._userService.fetchDetails()]);
  }
}
